// Library Methods
import { useMemo } from "react";
import { HubConnection } from "@microsoft/signalr";

// Components
import Box from "@mui/material/Box";
import WebRtc from "./WebRtc/WebRtc";
import LiveUpdateEyeStream from "../LiveUpdateEyeStream/LiveUpdateEyeStream";
import Graphs from "./Graphs/Graphs";

// Contexts
import { useLiveUpdateContext } from "src/contexts/live-update/LiveUpdateContext";

type LiveUpdateContentType = {
  connection: HubConnection | null;
};

const LiveUpdateContent = ({ connection }: LiveUpdateContentType) => {
  const {
    isVrMode,
    isVideo,
    isIOLSimulation,
    isProgressiveSimulation,
    isDryEyeSimulation,
    canDisplayEyeStream,
  } = useLiveUpdateContext();

  const displayVRMode = useMemo(() => {
    // show stream if the exam is not a simulation
    // or if the exam type is a video
    const showVR =
      isVrMode &&
      !isIOLSimulation &&
      !isProgressiveSimulation &&
      !isDryEyeSimulation;
    const showVideo = isVideo;

    return showVR || showVideo;
  }, [
    isVrMode,
    isIOLSimulation,
    isProgressiveSimulation,
    isDryEyeSimulation,
    isVideo,
  ]);

  return displayVRMode ? (
    <Box sx={{ height: "50dvh" }}>
      <WebRtc connection={connection} />
    </Box>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {canDisplayEyeStream && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
          }}
        >
          <LiveUpdateEyeStream connection={connection} />
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "50dvh",
          maxHeight: "fit-content",
          overflow: "hidden",
        }}
      >
        <Graphs connection={connection} />
      </Box>
    </Box>
  );
};

export default LiveUpdateContent;
